export default __webpack_public_path__ + "static/media/gallery-wip-denix-grips_01.09584e77.jpg";